import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';

import {cn} from 'spa/css';

import OptionsList from 'spa/Components/OptionsList';
import EnvSplit from 'spa/Components/EnvSplit';

const noop = () => {};

@withI18n
class Select extends React.Component {
  static propTypes = {
    align: PropTypes.string,
    className: PropTypes.string,
    classNameDisabled: PropTypes.string,
    classNameOpen: PropTypes.string,
    defaultValue: PropTypes.any,
    disabled: PropTypes.bool,
    listClassName: PropTypes.string,
    name: PropTypes.string,
    newLayout: PropTypes.bool,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
      disabled: PropTypes.bool,
    })).isRequired,
    required: PropTypes.bool,
    style: PropTypes.object,
    value: PropTypes.any,
    wrap: PropTypes.func,
    zIndex: PropTypes.number,
  };

  static defaultProps = {
    listClassName: 'form-select-options-list',
    className: 'form-control form-select-trigger',
    classNameOpen: 'form-select-trigger--open',
    classNameDisabled: 'form-select-trigger--disabled',
    wrap: (x, y) => (
      <span className="form-select__selected-wrapper">{x}
        {y && (
          <span className="form-select__subtext">{y}</span>
        )}
        <i className="form-select-trigger-icon fa fa-angle-down" />
      </span>
    ),
  };

  state = {
    open: false,
    selected: this.props.defaultValue || '',
  };

  UNSAFE_componentWillMount() {
    if (this.props.value !== undefined) {
      this.setState({selected: this.props.value});
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== undefined) {
      this.setState({selected: nextProps.value});
    }
    if (nextProps.disabled) {
      if (this.state.open) {
        this.setState({open: false});
      }
    }
  }

  get validity() {
    return this.input && this.input.validity;
  }

  setCustomValidity(...args) {
    return this.input && this.input.setCustomValidity && this.input.setCustomValidity(...args);
  }

  @autobind onFocusInput() {
    if (this.timeout) clearTimeout(this.timeout);
    if (!this.props.disabled) {
      this.setState({open: true});
    }
  }
  @autobind onBlurInput() {
    // FIXME - race condition: blur happens on mousedown. click happens on mouseup.
    // if mouse is down, this should be ignored.
    this.timeout = setTimeout(
      () => this.setState({open: false}),
      300,
    );
  }

  @autobind toggleOpen(event) {
    if (event) {
      event.preventDefault();
    }

    if (this.timeout) clearTimeout(this.timeout);
    if (this.props.disabled) {
      if (this.state.open) {
        this.setState({open: false});
      }
    } else {
      this.setState(({open}) => ({open: !open}));
    }
  }

  @autobind onClose(event) {
    if (event) {
      event.preventDefault();
    }

    if (this.timeout) clearTimeout(this.timeout);
    this.setState({
      open: false,
    });
  }

  @autobind onSelect(selected) {
    if (this.props.value !== undefined) {
      if (this.props.onChange) {
        this.input.value = selected;
        // FIXME - this is very bad
        this.props.onChange({
          target: this.input,
          currentTarget: this.input,
        });
      } else {
        console.error('Missing attribute `onChange`');
      }
    } else {
      if (this.props.onChange) {
        this.input.value = selected;

        this.props.onChange({
          target: this.input,
          currentTarget: this.input,
          value: selected,
        });
      }
      this.setState({selected});
    }
    this.setState({open: false});
  }

  @autobind inputRef(input) {
    this.input = input;
  }

  render() {
    const {i18n} = this.context;
    const {selected, open} = this.state;
    const {
      options, name, value, defaultValue, onChange, wrap,
      listClassName,
      className, classNameOpen, style, classNameDisabled,
      align,
      disabled, required, newLayout,
      zIndex,
      ...rest
    } = this.props;
    const selectedOption = options.find(option => selected === option.value);
    const selectedLabel = selectedOption && selectedOption.label || i18n._x('Please select...', 'Dropdown default selected value');
    const selectedSubText = selectedOption && selectedOption.subtext || null;

    return (
      <EnvSplit
        browser={() => (
          <OptionsList
            {...rest}
            align={align}
            options={options.map(option => ({
              name: option.label,
              subtext: option.subtext,
              value: option.value,
              selected: selected === option.value,
              className: option.className,
            }))}
            hide={!open}
            onClose={this.onClose}
            onSelect={this.onSelect}
            className={listClassName}
            data-qa={`${name}-select-input`}
            name={name}
            onClick={this.toggleOpen}
            containerStyle={style}
            containerClassName={cn(
              className,
              open && classNameOpen,
              disabled && classNameDisabled,
            )}
            disabled={disabled}
            zIndex={zIndex}
          >
            <input
              ref={this.inputRef}
              type="text"
              className="visuallyhidden"
              data-qa={`${name}-input`}
              name={name}
              value={selected}
              onChange={noop}
              disabled={disabled}
              required={required}
              onFocus={this.onFocusInput}
              onBlur={this.onBlurInput}
            />
            {wrap(selectedLabel, selectedSubText, open)}
          </OptionsList>
        )}
        server={() => (
          <div
            style={style}
            className={className}
          >
            <input
              ref={this.inputRef}
              type="text"
              className="visuallyhidden"
              name={name}
              value={selected}
              onChange={noop}
              disabled={disabled}
              required={required}
              onFocus={this.onFocusInput}
              onBlur={this.onBlurInput}
            />
            {wrap(<select
              name={name}
              value={value}
              defaultValue={defaultValue}
              onChange={noop}
              disabled={disabled}
              required={required}
              {...rest}>
              {options.map(this.renderOption, this)}
            </select>)}
          </div>
        )}
      />
    );
  }

  renderOption({label, subtext, ...rest}) {
    return (
      <option key={rest.value} {...rest}>{label}</option>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./spa/Components/Form/Select.jsx